import { useEffect, useMemo, useState } from "react"
import { isMobile as isMobileDetect } from "react-device-detect"
import useMediaQuery from "../hooks/useMediaQuery"
import useCustomStore from "../hooks/useCustomStore"
import { DEVICE_TYPES } from "@repo/utils/constants"
import { IS_DESKTOP_CSS_QUERY, IS_LANDSCAPE_CSS_QUERY, IS_MOBILE_CSS_QUERY } from "../constants/index.mjs"
import { generateStore } from "@repo/utils"

const INIT_CONTEXT = Object.freeze({
	isDesktop: true,
	isTablet: false,
	isMobile: false,
	device: DEVICE_TYPES.DESKTOP,
	deviceType: DEVICE_TYPES.DESKTOP,
	orientation: "landscape",
})

const useDeviceStore = generateStore(INIT_CONTEXT)

export default function DeviceProvider({ children }) {
	const [isMobileDevice, setMobileDevice] = useState(false)
	const isMobile = useMediaQuery(IS_MOBILE_CSS_QUERY)
	const isSimpleDesktop = useMediaQuery(IS_DESKTOP_CSS_QUERY)
	const isLandscape = useMediaQuery(IS_LANDSCAPE_CSS_QUERY)
	const isDesktop = useMemo(() => isSimpleDesktop && isLandscape, [isLandscape, isSimpleDesktop])

	const setStoreProp = useDeviceStore((state) => state.setStoreProp)

	useEffect(() => {
		setMobileDevice(isMobileDetect)
	}, [])

	useEffect(() => {
		setStoreProp("isMobile", isMobile)
		setStoreProp("isTablet", !isMobile && !isDesktop)
		setStoreProp("isDesktop", isDesktop)
		setStoreProp("device", isMobileDevice ? DEVICE_TYPES.MOBILE : DEVICE_TYPES.DESKTOP)
		setStoreProp("deviceType", isMobile ? DEVICE_TYPES.MOBILE : isDesktop ? DEVICE_TYPES.DESKTOP : DEVICE_TYPES.TABLET)
		setStoreProp("orientation", isLandscape ? "landscape" : "portrait")
	}, [isMobile, isLandscape, isMobileDevice, isDesktop])

	return children
}

export function useDevice(selector) {
	return useCustomStore(useDeviceStore, selector)
}

export function useIsDesktop(deviceCheck = false) {
	const isDesktopQuery = useDevice("isDesktop")
	const device = useDevice("device")
	if (!deviceCheck) return isDesktopQuery
	return isDesktopQuery && device !== DEVICE_TYPES.MOBILE
}

export function useIsTablet(deviceCheck = false) {
	const isTabletQuery = useDevice("isTablet")
	const device = useDevice("device")
	if (!deviceCheck) return isTabletQuery
	return isTabletQuery && device === DEVICE_TYPES.MOBILE
}

export function useIsMobile(deviceCheck = false) {
	const isMobileQuery = useDevice("isMobile")
	const device = useDevice("device")
	if (!deviceCheck) return isMobileQuery
	return isMobileQuery && device === DEVICE_TYPES.MOBILE
}
